import { configureStore } from '@reduxjs/toolkit';
import sessionReducer from './slices/sessionSlice';
import loadingReducer from './slices/loadingSlice';
import workflowReducer from './slices/workflowSlice';

const store = configureStore({
  reducer: {
    session: sessionReducer,
    loading: loadingReducer,
    workflow: workflowReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar estas acciones si usas persistencia
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
